import { Autocomplete, TextField } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const getSelectedUserOption = (users, person) => {
    if (!person) return null

    const personId = person?._id || person
    return users.find((user) => user.value === personId) || (
        person?._id
            ? { value: person._id, label: `${person.firstName || ""} ${person.lastName || ""}`.trim() }
            : null
    )
}

const Custom = ({ quote, patchQuote, flushQuotePatch, users = [], readOnly = false }) => {
    const fields = [
        { label: "Order Number", value: "poNumber" },
        { label: "Estimated Delivery", value: "leadTime" },
        { label: "Quote Revision", value: "revision", disabled: true },
        { label: "Drawing Number", value: "salesDrawing" },
    ]
    return (
        <div className="hive-quote-custom" style={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
            <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                <Autocomplete
                    options={users}
                    value={getSelectedUserOption(users, quote?.projectManager)}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    onChange={(e, newValue) => {
                        patchQuote({ projectManager: newValue ? newValue.value : null });
                    }}
                    disabled={readOnly}
                    renderInput={(params) => <TextField {...params} label="Project Manager" />}
                />
            </div>

            <div className="col-12 col-sm-8" style={{ margin: "0.5em" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label="Order Date"
                        value={quote?.orderDate ? new Date(quote.orderDate) : null}
                        onChange={(date) => patchQuote({ orderDate: date || null })}
                        disabled={readOnly}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                sx: { mt: 2, mb: 2 },
                            },
                        }}
                    />
                </LocalizationProvider>
            </div>

            {fields.map(field => (
                <div key={field.value} className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                    <TextField
                        fullWidth
                        label={field.label}
                        value={quote?.[field.value] ?? ""}
                        onChange={(e) => patchQuote({ [field.value]: e.target.value })}
                        onBlur={flushQuotePatch}
                        disabled={field?.disabled || readOnly}
                    />
                </div>
            ))}

            <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                <TextField
                    fullWidth
                    label="Quote Creator"
                    disabled
                    value={quote?.createdBy ? `${quote?.createdBy.firstName} ${quote?.createdBy.lastName}` : ""}
                />
            </div>

        </div>
    )
}

export default Custom
